// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAZmN_ALO8xCruB8wlH4lHvbgIz4QS20aI",
  authDomain: "yippity-4cb5e.firebaseapp.com",
  projectId: "yippity-4cb5e",
  storageBucket: "yippity-4cb5e.appspot.com",
  messagingSenderId: "330802470593",
  appId: "1:330802470593:web:6d8d13fb228b08c3e17e40",
  measurementId: "G-DGCQHLR54H",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
